"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Request {
    constructor() {
        this.type = 'common-fission';
        const { request } = require('@futuweb/fego-render').common;
        this.commonApi = request.bindCommonApi(this.type);
    }
    /**
     * 获取短链接
     * @param body - 请求参数，包含需要生成短链的链接数组
     * @returns 返回包含短链接数组的响应对象
     */
    async getFissionList(body) {
        const res = await this.commonApi.post('getFissionList', Object.assign({}, body));
        return res;
    }
    /**
     * 邀请人向指定受邀人发送提醒 Push（模板 IM）
     */
    async remindInvitee(body) {
        await this.commonApi.post('remindInvitee', Object.assign({}, body));
    }
}
exports.default = new Request();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJlcXVlc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFLQSxNQUFNLE9BQU87SUFLVDtRQUpBLFNBQUksR0FBRyxnQkFBZ0IsQ0FBQztRQUtwQixNQUFNLEVBQUUsT0FBTyxFQUFFLEdBQUcsT0FBTyxDQUFDLHNCQUFzQixDQUFDLENBQUMsTUFBTSxDQUFDO1FBQzNELElBQUksQ0FBQyxTQUFTLEdBQUcsT0FBTyxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdEQsQ0FBQztJQUVEOzs7O09BSUc7SUFDSCxLQUFLLENBQUMsY0FBYyxDQUFDLElBQXFCO1FBQ3RDLE1BQU0sR0FBRyxHQUFHLE1BQU0sSUFBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsZ0JBQWdCLG9CQUFPLElBQUksRUFBRyxDQUFDO1FBQ3JFLE9BQU8sR0FBRyxDQUFDO0lBQ2YsQ0FBQztJQUVEOztPQUVHO0lBQ0gsS0FBSyxDQUFDLGFBQWEsQ0FBQyxJQUF1QjtRQUN2QyxNQUFNLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLGVBQWUsb0JBQU8sSUFBSSxFQUFHLENBQUM7SUFDNUQsQ0FBQztDQUNKO0FBRUQsa0JBQWUsSUFBSSxPQUFPLEVBQUUsQ0FBQyJ9